import determineOfferFeatureSymbol from 'lib/offer/determineOfferFeatureSymbol'

const POOL_DESCRIPTION_PATTERN = /\b(swimming|pool)\b/i
const POOL_TABLE_PATTERN = /\bpool tables?\b/i

function isPoolFacility(facility: string): boolean {
  return POOL_DESCRIPTION_PATTERN.test(facility) && !POOL_TABLE_PATTERN.test(facility)
}

function mapFacility(facility: string): App.OfferInclusion {
  return {
    id: facility,
    description: facility,
    symbol: determineOfferFeatureSymbol(facility),
  }
}

export default function getBedbankCardAmenities(popularFacilities: Array<string>): Array<App.OfferInclusion> {
  return [
    ...popularFacilities.filter(isPoolFacility),
    ...popularFacilities.filter(facility => !isPoolFacility(facility)),
  ].map(mapFacility)
}
